import { Component, Input } from '@angular/core';

/** Preview for `continue_execution`: how long it has run, and how far it got. */
@Component({
  selector: 'app-continue-execution-preview',
  templateUrl: './continue-execution-preview.component.html',
  styleUrls: ['./continue-execution-preview.component.scss'],
})
export class ContinueExecutionPreviewComponent {
  @Input() previewData: {
    message?: string;
    elapsed_seconds?: number;
    tasks_done?: number;
    tasks_total?: number;
  };
  @Input() actionData: {
    reason?: string;
    elapsed_seconds?: number;
    prompt_number?: number;
    max_prompts?: number;
    tasks_done?: number;
    tasks_total?: number;
  };

  get data() {
    return { ...(this.actionData || {}), ...(this.previewData || {}) };
  }

  get elapsedSeconds(): number {
    return this.data.elapsed_seconds ?? 0;
  }

  /** "1m 32s" beats "92s" past a minute. */
  get elapsedLabel(): string {
    const total = this.elapsedSeconds;
    if (total < 60) return `${total}s`;
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;
    return seconds ? `${minutes}m ${seconds}s` : `${minutes}m`;
  }

  get tasksTotal(): number {
    return this.data.tasks_total ?? 0;
  }

  get tasksDone(): number {
    return this.data.tasks_done ?? 0;
  }

  /** Hidden when the query produced no plan (DIRECT/AGENT routes). */
  get hasPlan(): boolean {
    return this.tasksTotal > 0;
  }

  get progressPercent(): number {
    if (!this.hasPlan) return 0;
    return Math.round((this.tasksDone / this.tasksTotal) * 100);
  }
}
